import { useTranslation } from "react-i18next";

import { Text, ThemeColorVariable, ThemeFontSizeVariable, TStep } from "@caspeco/casper-ui-library";

export const CanceledStep = (): TStep => {
	const { t } = useTranslation();
	return {
		label: (
			<Text
				fontWeight="medium"
				color={ThemeColorVariable.OnBackgroundHeader}
				fontSize={ThemeFontSizeVariable.Medium}
			>
				{t("order_denied")}
			</Text>
		),
		color: ThemeColorVariable.Error,
		iconColor: ThemeColorVariable.OnError,
		icon: "times",
	};
};
